import { Link } from 'react-router-dom';

import SeletorDeCiclo, { CicloDoSeletor } from 'components/ui/seletor-de-ciclo';
import { FOCO_VISIVEL } from 'utils/foco';

interface CabecalhoDoCatalogoProps {
  ciclos: CicloDoSeletor[];
  cicloId?: string;
  onCiclo: (id: string) => void;
}

/** Voltar, título e seletor de ciclo (CAT-01, CAT-30). */
export default function CabecalhoDoCatalogo({ ciclos, cicloId, onCiclo }: CabecalhoDoCatalogoProps) {
  return (
    <div className="mb-[22px] flex flex-wrap items-center gap-3.5">
      <Link
        to="/"
        aria-label="Voltar"
        className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-blue ${FOCO_VISIVEL}`}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--brand-yellow)" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
          <path d="m15 18-6-6 6-6" />
        </svg>
      </Link>
      <h1 tabIndex={0} className={`m-0 font-display text-[24px] font-extrabold leading-[normal] text-brand-blue-dark sm:text-[28px] ${FOCO_VISIVEL}`}>
        Catálogo de Experiências
      </h1>
      {ciclos.length > 0 && <SeletorDeCiclo ciclos={ciclos} valor={cicloId} onChange={onCiclo} className="w-full sm:ml-auto sm:w-[220px]" />}
    </div>
  );
}
